import { GOOGLE_MAPS_API_KEY } from "@appConfig/api-keys"

let googleMapsLoaderPromise = null

export function loadGoogleMaps (libraries = []) {
  if (window.google?.maps) return Promise.resolve(window.google.maps)

  if (googleMapsLoaderPromise) return googleMapsLoaderPromise

  googleMapsLoaderPromise = new Promise((resolve, reject) => {
    const callbackName = "__stimulusGoogleMapsInit"
    window[callbackName] = () => {
      delete window[callbackName]
      resolve(window.google.maps)
    }

    const params = new URLSearchParams({
      key: GOOGLE_MAPS_API_KEY,
      callback: callbackName
    })
    if (libraries.length) params.set("libraries", libraries.join(","))

    const script = document.createElement("script")
    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`
    script.async = true
    script.onerror = () => {
      delete window[callbackName]
      googleMapsLoaderPromise = null
      reject(new Error("Failed to load Google Maps"))
    }
    document.head.appendChild(script)
  })

  return googleMapsLoaderPromise
}
